export default function itemActualCost(itemData,itemCount,type){
    let itemCost,itemDiscount;

    if(type==="store"){
        itemCost = itemData.item_cost();
        itemDiscount = itemData.item_discount();
    }else{
        itemCost = itemData.purchase_cost();
        itemDiscount = itemData.purchase_discount();
    }
    
    const itemActualCost = (itemCost-(itemCost*(itemDiscount/100)))*itemCount;

    return itemActualCost;
}
